import { createAsyncThunk } from '@reduxjs/toolkit';
import { NotificationService } from '@core/services/notifiAdmin.service.ts';

const service = new NotificationService();

export const fetchNotifications = createAsyncThunk(
  'notification/fetchAll',
  async () => {
    const res = await service.getAllNotifications();
    return res;
  }
);

export const markNotificationAsRead = createAsyncThunk(
  'notification/markAsRead',
  async (id: number) => {
    await service.markAsRead(id);
    return id;
  }
);

export const markNotificationAsUnread = createAsyncThunk(
  'notification/markAsUnread',
  async (id: number) => {
    await service.markAsUnread(id);
    return id; 
  }
);

export const markAllNotificationsAsRead = createAsyncThunk(
  'notification/markAllAsRead',
  async () => {
    await service.markAllAsRead();
    return; 
  }
);
